import { c as _c } from "react/compiler-runtime";
import { isChannel } from "@website/utils/channel/helpers";
import { FooterComponent } from "@website/widget/footer/footer.component";
import { FooterPropertiesType } from "@website/widget/footer/footer.types";
import { FC } from "react";
export const Footer: FC<FooterPropertiesType> = properties => {
  const $ = _c(3);
  if (isChannel(["android", "jek", "ads", "SNAPP_AD", "ads"])) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="h-12" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== properties) {
    t0 = <FooterComponent {...properties} />;
    $[1] = properties;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};